import DataTable from "@shared/ui/data-table/DataTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledCars } from "./cars.styled";
import { useCarOptions } from "./cars.data";
import { useCarStructures } from "./useCarStructures";
import { useCarsBrowse } from "./useCarsBrowse";
import { useCarsNavigation } from "./useCarsNavigation";

function Cars() {
  const theme = useTheme();
  const { tableStructure } = useCarStructures();
  const browse = useCarsBrowse();
  const navigation = useCarsNavigation();
  const carOptions = useCarOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledCars>
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          searchForm={browse.carSearchForm}
          onResetSearch={browse.reset}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={carOptions}
          selectRow={navigation.selectRow}
          onSelectRow={navigation.rowChosen}
          pagination={{
            page: browse.page,
            perPage: browse.perPage,
            hasNextPage: browse.hasNextPage,
            hasPrevPage: browse.hasPrevPage,
            onNextPage: browse.handleNextPage,
            onPrevPage: browse.handlePrevPage,
            onRowsPerPageChange: browse.handleRowsPerPageChange,
          }}
        />
      ) : (
        <Skeleton variant="rectangular" height={150} animation="wave" sx={skeletonSx} />
      )}
    </StyledCars>
  );
}

export default Cars;
